export function getTimeRequestSelectorsDefault() {
    return Array.from({ length: 3 }).map(() => ({
        date: undefined,
        time: undefined,
        id: undefined,
    }))
}
